module.exports = "https://static.zego.com/_next/static/images/SDP-9e189e5c5fdca4799dcf0b4c3461d45b.svg";